import React, { useEffect, useState } from "react";
import { useTranslate } from "../../hooks/useTranslate";
import Barra from "../Barra";
import Button from "../Button";
import { Heading } from "../Heading";
import { GridContainer } from "../shared";
import * as S from "./styled";

export function Jobs() {
  const [jobs, setJobs] = useState([]);

  const { t } = useTranslate("talents.jobs");

  useEffect(() => {
    fetch("https://apply.workable.com/api/v1/widget/accounts/axur?details=true")
      .then((response) => response.json())
      .then((data) => setJobs(data.jobs))
      .catch((error) => console.log(`Ops! ${error}`));
  }, []);

  return (
    <S.JobsWrapper id="jobs">
      <Barra />

      <Heading marginBottom={24}>{t("title")}</Heading>
      <p>{t("text")}</p>

      <GridContainer gap={32} marginBottom={48}>
        {!jobs.length && <p>Buscando vagas...</p>}

        {jobs.map(
          ({ shortcode, url, title, department, telecommuting }) =>
            shortcode !== "32E580D693" && (
              <S.BoxJob
                key={shortcode}
                href={url}
                target="_blank"
                rel="noreferrer"
              >
                <strong>{department}</strong>
                <Heading as="h3" size="small">
                  {title}
                </Heading>
                {telecommuting && <span>REMOTE</span>}
              </S.BoxJob>
            )
        )}
      </GridContainer>

      <Heading marginBottom={24}>{t("cta.title")}</Heading>
      <p>{t("cta.text")}</p>
      <Button
        typeButton="cta"
        href="https://apply.workable.com/axur/j/32E580D693/"
      >
        {t("cta.btn")}
      </Button>
    </S.JobsWrapper>
  );
}
